import * as inspector from "inspector-v2/legacy/legacy";
export { inspector };
export default inspector;
